import axios from 'axios';
import requests from '../util';

const { request } = requests;

const getPresignedUrl = async ({ filename, mimeType, requestType }) => {
  try {
    return await request({
      url: '/api/v1/request/presignedUrl',
      method: 'get',
      params: { filename, mimeType, requestType },
    });
  } catch (error) {
    throw error;
  }
};
const putImageToS3 = async (url, file, onProgressCallBack) => {
  try {
    const response = await axios.put(url, file, {
      headers: {
        'Content-Type': file.type,
      },
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        let percent = Math.floor((loaded * 99) / total);
        onProgressCallBack(percent);
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getThumbPathOfImage = async ({ key }) => {
  try {
    return request({
      url: '/api/v1/util/createThumbnail',
      method: 'post',
      body: { key },
    });
  } catch (error) {
    throw error;
  }
};

const getCreditStatusForGeneration = async ({
  backgroundId,
  modelId,
  inputFiles,
  requestType,
}) => {
  try {
    return request({
      url: '/api/v1/request/costPublic',
      method: 'post',
      body: { backgroundId, modelId, inputFiles, requestType },
    });
  } catch (error) {
    throw error;
  }
};

const getToSelectSampleImages = async ({}) => {
  try {
    return request({
      url: '/api/v1/sample?sampleType=modelClipperInputFile',
      method: 'get',
    });
  } catch (error) {
    throw error;
  }
};

const getPollOfTasks = async ({ taskIds }) => {
  try {
    return request({
      url: '/api/v1/task/pollTasks',
      method: 'get',
      params: {
        taskIds: JSON.stringify(taskIds),
      },
    });
  } catch (error) {
    throw error;
  }
};

const getCreditsAvailable = async () => {
  try {
    return request({
      url: '/api/v1/user/creditsAvailable',
      method: 'get',
    });
  } catch (error) {
    throw error;
  }
};

const getCreditUsageData = async (fromDate, toDate) => {
  console.log(fromDate, toDate);
  return request({
    url: '/api/v1/user/creditUsage',
    method: 'get',
    params: {
      fromDate,
      toDate,
    },
  });
};
const fetchUserDetails = async () => {
  try {
    return request({
      url: '/api/v1/user/userInfo',
      method: 'get',
    });
  } catch (error) {
    throw error;
  }
};

const submitUserDetails = async (payload) => {
  try {
    return request({
      url: '/api/v1/user/userInfo ',
      method: 'patch',
      body: payload,
    });
  } catch (error) {
    throw error;
  }
};

const submitUserPassword = async (payload) => {
  try {
    return request({
      url: '/api/v1/user/updatePassword',
      method: 'patch',
      body: payload,
    });
  } catch (error) {
    throw error;
  }
};
const getMultipleCostCreditGeneration = async (payload) => {
  return request({
    url: '/api/v1/request/multiCostCalcPublic',
    method: 'post',
    body: { entries: payload },
  });
};
const miscApi = {
  getPresignedUrl,
  putImageToS3,
  getCreditStatusForGeneration,
  getThumbPathOfImage,
  getToSelectSampleImages,
  getPollOfTasks,
  getCreditsAvailable,
  getCreditUsageData,
  fetchUserDetails,
  submitUserDetails,
  submitUserPassword,
  getMultipleCostCreditGeneration,
};

export default miscApi;
